<ng-template #content_language_selection let-offcanvas>
  <div class="{{localService.selectedLanguageCode}}"
    *ngIf="localService.languageContent && localService.languageContent.common && languages">
    <div class="side_popup_header">
      <span>{{localService.languageContent.common.language_selection_header}}</span>
      <button class="button_icon" (click)="onCloseTrigger()">close</button>
    </div>
    <div class="side_popup_body" [ngStyle]="{'max-height' : (localService.sideBarBodyHeight + (isShowAll ? 0 : 50)) + 'px'}"
      *ngIf="localService.languages">
      <div class="row">
        <div class="col-12">
          <input autocomplete="off" type="text" style="margin-bottom: 10px;" [(ngModel)]="searchKey"
            title="{{localService.languageContent.common.search}}" id="{{elementIds.txt_search_key}}"
            placeholder="{{localService.languageContent.common.search}}" (input)="onFilterLanguage()" />
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <app-list-options [items]="languages" [selectedKey]="localService.selected.applicationLanguage"
            [isShowEquivalentLanguage]="true" (onSelectionChanged)="onSelectionChanged($event)"></app-list-options>
        </div>
      </div>
    </div>
    <div class="side_popup_footer" *ngIf="isShowAll">
      <button type="button" class="btn btn-primary"
        (click)="onSelectionChanged(undefined)">{{localService.languageContent.common.all}}</button>
    </div>
  </div>
</ng-template>